import React from 'react'

import Checkbox from "components/CheckboxCustom";
import ReserveDate from "components/SearchComponents/ReserveDate";
import Passengers from "components/SearchComponents/Passengers";
import Offers from "components/SearchComponents/Offers"

import {TbPlaneDeparture, TbPlaneArrival} from 'react-icons/tb';
import {LocationAirfare} from "components/SearchComponents/LocationAirfare";

export default function () {

    //const { pass } = useSearch()
    //const { onlyDeparture, changeOnlyDeparture } = pass

    return (
        <div className="box-search">
            <LocationAirfare />

            <div className="d-grid gap-3">
                <ReserveDate
                    iconStart={<TbPlaneDeparture/>}
                    iconEnd={<TbPlaneArrival/>}
                    placeholderStart="Ida"
                    placeHolderEnd="Volta"
                    onlyDeparture={false}
                    page="airfare"
                />

                <Checkbox
                    onChange={() => {}}
                    checked={false}
                    label="Apenas ida"
                />
            </div>

            <Passengers />

            <Offers />
        </div>
    )
}
